import { Helmet } from 'react-helmet-async';
import { useQuery } from '@tanstack/react-query';
import { blogApi } from '../lib/api';
import { Link } from 'react-router-dom';

export function BlogPage() {
  const { data: posts, isLoading } = useQuery({
    queryKey: ['blog', true],
    queryFn: () => blogApi.getAll(true).then((res) => res.data),
  });

  return (
    <>
      <Helmet>
        <title>Blog - {import.meta.env.VITE_APP_NAME || 'KUMBİLGİ'}</title>
        <meta name="description" content={`${import.meta.env.VITE_APP_NAME || 'KUMBİLGİ'} blog yazıları ve haberler`} />
      </Helmet>

      <div className="container-custom py-12">
        <h1 className="text-4xl font-bold mb-4">Blog</h1>
        <p className="text-xl text-gray-600 mb-12">
          Teknoloji dünyasından son haberler ve makaleler
        </p>

        {isLoading ? (
          <div className="text-center py-12">Yükleniyor...</div>
        ) : posts && posts.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((post: any) => (
              <Link
                key={post.id}
                to={`/blog/${post.slug}`}
                className="block bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow"
              >
                {post.coverImage && (
                  <img
                    src={post.coverImage}
                    alt={post.title}
                    className="w-full h-48 object-cover"
                  />
                )}
                <div className="p-6">
                  <h3 className="text-xl font-semibold mb-2">{post.title}</h3>
                  {post.excerpt && (
                    <p className="text-gray-600 mb-4 line-clamp-3">{post.excerpt}</p>
                  )}
                  <span className="text-primary-600 font-semibold">Devamını Oku →</span>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <div className="text-center py-12 text-gray-600">
            Henüz blog yazısı bulunmamaktadır.
          </div>
        )}
      </div>
    </>
  );
}

